module.exports = __webpack_public_path__ + "src/assets/games/42/70.jpg";